import React from 'react';
import { aboutParagraphs, governanceAreas, profile } from '../data/profile';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function AboutNarrative({
  showLabel = true
}: {
  showLabel?: boolean;
}) {
  return <section id="about" className="w-full bg-white py-20 lg:py-28" data-id="element-23" data-mp="1dukfjrh7p271">
      <div className="mx-auto max-w-shell px-6 sm:px-8" data-id="element-24" data-mp="1irstffvbuk2h">
        {showLabel && <Reveal data-id="element-25" data-mp="m3e80pz5w27q">
            <SectionLabel data-id="element-26" data-mp="m3wba6k8rgp5">Executive Biography</SectionLabel>
            <h2 className="mt-6 max-w-3xl font-serif text-[32px] font-semibold leading-[1.12] tracking-[-0.015em] text-navy sm:text-4xl lg:text-[44px]" data-id="element-27" data-mp="q3x1eogpdgc1">
              Thirty-nine years inside the operations of multinational enterprises
            </h2>
          </Reveal>}

        <div className={`grid grid-cols-1 gap-12 lg:grid-cols-[0.42fr_0.58fr] lg:gap-20 ${showLabel ? 'mt-14' : ''}`} data-id="element-28" data-mp="zvui2aqhd0i5">
          <Reveal data-id="element-29" data-mp="7c48sv5jpx4u">
            <div className="flex h-full flex-col justify-between bg-canvas p-9 lg:p-10" data-id="element-30" data-mp="7bm4rccn6emd">
              <div data-id="element-31" data-mp="2m9xgkctp12un">
                <span className="text-[11px] font-semibold uppercase tracking-label text-metal" data-id="element-32" data-mp="2mcjmk80xraar">
                  Executive Positioning
                </span>
                <p className="mt-6 font-serif text-[23px] leading-[1.45] text-navy lg:text-[26px]" data-id="element-33" data-mp="2dh3wm23axfag">
                  {profile.positioning}
                </p>
              </div>
              <div className="mt-9 border-t border-line pt-6" data-id="element-34" data-mp="23khcxgmpoua0">
                <span className="block text-sm font-semibold text-navy" data-id="element-35" data-mp="1yl4hi7hryevt">{profile.name}</span>
                <span className="mt-1 block text-[12px] font-medium uppercase tracking-label text-charcoal-muted" data-id="element-36" data-mp="1ynh6v5pv3riw">
                  Elizabethtown, Kentucky · Available globally
                </span>
              </div>
            </div>
          </Reveal>

          <div data-id="element-37" data-mp="3ow93zjedo20e">
            <div className="space-y-5" data-id="element-38" data-mp="3owsmb17xwsey">
              {aboutParagraphs.map((paragraph, index) => <Reveal key={paragraph.slice(0, 24)} delay={index * 0.05} data-id="element-39" data-mp="3jz8vl1u22n64" data-mpi={index}>
                  <p className={`leading-[1.75] ${index === 0 ? 'text-[17px] text-charcoal' : 'text-[16px] text-charcoal-light'}`} data-id="element-40" data-mp="6wwp2d3r6icz">
                    {paragraph}
                  </p>
                </Reveal>)}
            </div>

            <dl className="mt-10 grid grid-cols-1 gap-x-10 gap-y-7 sm:grid-cols-2" data-id="element-41" data-mp="2wcvtkmavyw4">
              {governanceAreas.map((area, index) => <Reveal key={area.title} delay={index * 0.05} data-id="element-42" data-mp="unsp1xid4jvb" data-mpi={index}>
                  <div className="border-t border-navy/15 pt-5" data-id="element-43" data-mp="ul6gbujqjybi">
                    <dt className="text-[15px] font-semibold text-navy" data-id="element-44" data-mp="gmpzhas5srfn">{area.title}</dt>
                    <dd className="mt-2 text-[14px] leading-relaxed text-charcoal-muted" data-id="element-45" data-mp="lljg3c2qsyk1">
                      {area.description}
                    </dd>
                  </div>
                </Reveal>)}
            </dl>
          </div>
        </div>

        <Reveal data-id="element-46" data-mp="2ytalfkl9l99i">
          <p className="mt-14 border-l-2 border-metal pl-6 font-serif text-[21px] leading-[1.5] text-navy lg:text-[24px]" data-id="element-47" data-mp="2yssrium2r74r">
            {profile.valueStatement}
          </p>
        </Reveal>
      </div>
    </section>;
}